var map = {
	"./arrizo8/arrizo8.png": 8561,
	"./arrizo8/slider/slider-1.png": 7131,
	"./arrizo8/slider/slider-2.png": 8800,
	"./arrizo8/slider/slider-3.png": 3273,
	"./arrizo8/slider/slider-4.png": 3190,
	"./tenet4/tenet4.png": 8819,
	"./tenet7/tenet7.png": 7861,
	"./tenet8/tenet8.png": 5195,
	"./tiggo4new/tiggo4new.png": 3145,
	"./tiggo4pro/slider/slider-1.png": 5953,
	"./tiggo4pro/slider/slider-2.png": 8522,
	"./tiggo4pro/slider/slider-3.png": 435,
	"./tiggo4pro/slider/slider-4.png": 3036,
	"./tiggo4pro/tiggo4pro.png": 4477,
	"./tiggo7/slider/slider-1.png": 8525,
	"./tiggo7/slider/slider-2.png": 7846,
	"./tiggo7/slider/slider-3.png": 5935,
	"./tiggo7/slider/slider-4.png": 7280,
	"./tiggo7/tiggo7.png": 117,
	"./tiggo7l/tiggo7l.png": 4569,
	"./tiggo7pro/slider/slider-1.png": 6660,
	"./tiggo7pro/slider/slider-2.png": 8287,
	"./tiggo7pro/slider/slider-3.png": 4486,
	"./tiggo7pro/slider/slider-4.png": 4457,
	"./tiggo7pro/tiggo7pro.png": 1561,
	"./tiggo7promax/slider/slider-1.png": 3052,
	"./tiggo7promax/slider/slider-2.png": 3735,
	"./tiggo7promax/slider/slider-3.png": 7950,
	"./tiggo7promax/slider/slider-4.png": 2513,
	"./tiggo7promax/tiggo7promax.png": 1147,
	"./tiggo7proplugin/slider/slider-1.png": 9245,
	"./tiggo7proplugin/slider/slider-2.png": 8038,
	"./tiggo7proplugin/slider/slider-3.png": 3231,
	"./tiggo7proplugin/slider/slider-4.png": 4208,
	"./tiggo7proplugin/tiggo7proplugin.png": 7057,
	"./tiggo8/slider/slider-1.png": 8406,
	"./tiggo8/slider/slider-2.png": 29,
	"./tiggo8/slider/slider-3.png": 3732,
	"./tiggo8/slider/slider-4.png": 5387,
	"./tiggo8/tiggo8.png": 8095,
	"./tiggo8pro/slider/slider-1.png": 933,
	"./tiggo8pro/slider/slider-2.png": 3582,
	"./tiggo8pro/slider/slider-3.png": 1895,
	"./tiggo8pro/slider/slider-4.png": 376,
	"./tiggo8pro/tiggo8pro.png": 9301,
	"./tiggo8promax/slider/slider-1.png": 6403,
	"./tiggo8promax/slider/slider-2.png": 4440,
	"./tiggo8promax/slider/slider-3.png": 1921,
	"./tiggo8promax/slider/slider-4.png": 7086,
	"./tiggo8promax/tiggo8promax.png": 753,
	"./tiggo8proplugin/slider/slider-1.png": 7988,
	"./tiggo8proplugin/slider/slider-2.png": 6799,
	"./tiggo8proplugin/slider/slider-3.png": 1702,
	"./tiggo8proplugin/slider/slider-4.png": 329,
	"./tiggo8proplugin/tiggo8proplugin.png": 597,
	"./tiggo9/tiggo9.png": 6281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3784;